export default __webpack_public_path__ + "static/media/joao-paulo-pordeus.821e4c26.jpg";